import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgSg48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Singapore",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22 12a10 10 0 0 1-20 0l10.07-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d43630",
  d: "M2 12h20a10 10 0 0 0-20 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M8.09 7.22a3 3 0 0 1 2.39-3 3 3 0 0 0-.66-.07 3 3 0 0 0-1.25.25 2.9 2.9 0 0 0-1 .75 3.1 3.1 0 0 0-.65 1.1 3.05 3.05 0 0 0 .27 2.48 3 3 0 0 0 .87 1 3 3 0 0 0 1.17.5 2.9 2.9 0 0 0 1.28 0 3 3 0 0 1-2.39-3zM12 4.39l.22.66h.7l-.57.42.22.66-.57-.41-.57.41.22-.66-.56-.42h.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "m10.3 5.7.22.66h.7l-.56.41.21.66L10.3 7l-.56.41.26-.64-.57-.41h.7zm3.4 0 .21.66h.7l-.61.41.22.66L13.7 7l-.57.41.21-.66-.56-.41h.7zm-.66 2 .22.67H14l-.57.41.22.66L13 9l-.56.41.21-.66-.56-.41h.7zM11 7.65l.21.67h.71l-.57.41.21.66L11 9l-.57.41.22-.66-.65-.43h.7z"
}));

export { SvgSg48Rounded as default };
//# sourceMappingURL=Sg48Rounded.js.map
